(ns frontend.view.settings2.web-form.sub
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::selected-webentry-id
 (fn [db _]
   (get db ::selected-webentry-id)))
